import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function DropdownNavItem({ id, title, items = [] }) {
  const [open, setOpen] = useState(false);

  const hasItems = items.length > 0;

  return (
    <div
      className="nav-dd"
      onMouseEnter={() => hasItems && setOpen(true)}
      onMouseLeave={() => hasItems && setOpen(false)}
    >
      <a href={id} className="nav-dd__trigger">
        <span>{title}</span>

        {hasItems && (
          <ChevronDown
            className={`nav-dd__icon ${open ? "is-open" : ""}`}
            size={16}
            aria-hidden="true"
          />
        )}
      </a>

      {hasItems && (
        <div className={`nav-dd__menu ${open ? "is-open" : ""}`}>
          {items.map((it) => (
            <a key={it.href} href={it.href} className="nav-dd__item">
              {it.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}